import React, { useRef, useState } from "react";
import img from "../Images/5Clogo.png";
import img1 from "../Images/dropdown.png";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useAuth0 } from "@auth0/auth0-react";
import LoginIcon from '../Images/Login.svg'
import { useNavigate } from "react-router-dom";
import ls from "localstorage-slim";
import CryptoJS from "crypto-js";
import firebase from "../firebase";
import "./LoginPage.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

ls.config.encrypt = true;

function Login({ onLogin }) {
  const navigate = useNavigate();
  const { loginWithRedirect } = useAuth0();
  // const firebaseConfig = {
  //   apiKey: "AIzaSyDXgaC8agUeGevJJe3_1Iv-XAmiAXncnZo",
  //   authDomain: "auth-91372.firebaseapp.com",
  //   databaseURL: "https://auth-91372-default-rtdb.firebaseio.com",
  //   projectId: "auth-91372",
  //   storageBucket: "auth-91372.appspot.com",
  //   messagingSenderId: "1049468576541",
  //   appId: "1:1049468576541:web:d5122593640a0ba6e977f4",
  //   measurementId: "G-P402PDM7RJ"
  // };

  // const app = initializeApp(firebaseConfig);
  // const database= getDatabase(app)
  const auth = getAuth();

  const [email, setEmail] = React.useState("");
  const [pass, setPass] = React.useState("");
  const [showPass, setShowPass] = React.useState(true);

  const visibleRef = useRef(null);
  const hideRef = useRef(null);

  const handlePassShow = () => {
    if (showPass) {
      hideRef.current.style.display = "none";
      visibleRef.current.style.display = "flex";
      // visibleRef.current.style.position='absolute'
    }
  };

  const emailRef = useRef();
  const passRef = useRef();
  const errorMes = useRef();
  const menuRef = useRef();

  const handleInput = (event) => {
    setEmail(event.target.value);
    // //console.log(email)
  };

  const handleInput1 = (event) => {
    setPass(event.target.value);
  };

  const handleSubmit = () => {

    // loginWithRedirect()
    window.location.href = `${process.env.REACT_APP_BACKEND_API}login`

    // if (email === "" && pass === "") {
    //   errorMes.current.innerHTML = "Please enter the required details";
    //   errorMes.current.style.color = "red";
    //   passRef.current.style.border = "1px solid red";
    //   emailRef.current.style.border = "1px solid red";
    // } else if (email === "") {
    //   errorMes.current.innerHTML = "Please enter the email";
    //   errorMes.current.style.color = "red";
    //   emailRef.current.style.border = "1px solid red";
    // } else if (pass === "") {
    //   errorMes.current.innerHTML = "Please enter the Password";
    //   errorMes.current.style.color = "red";
    //   emailRef.current.style.border = "1px solid black";
    //   passRef.current.style.border = "1px solid red";
    // } else {
    //   firebase
    //     .auth()
    //     .signInWithEmailAndPassword(email, pass)
    //     .then((userCredential) => {
    //       // Signed in
    //       const user = userCredential.user;
    //       onLogin();
    //       if(localStorage.getItem('preventUrl')){
    //         window.location.href=localStorage.getItem('preventUrl')
    //         localStorage.removeItem('preventUrl')
    //       }
    //       navigate("/home");
    //       // ////console.log(user);
    //       // emailRef.current.style.border='1px solid green'
    //       //   passRef.current.style.border='1px solid green'
    //       //   errorMes.current.innerHTML='Login Successfully';
    //       //   errorMes.current.style.color='green';
    //       // ...
    //     })
    //     .catch((error) => {
    //       const errorCode = error.code;
    //       const errorMessage = error.message;
    //       //console.log(errorCode);
    //       //console.log(errorMessage);

    //       if (
    //         errorCode === "auth/user-not-found" ||
    //         errorCode === "auth/invalid-email"
    //       ) {
    //         emailRef.current.style.border = "1px solid red";
    //         passRef.current.style.border = "1px solid black";
    //         errorMes.current.innerHTML = "User Doesn't Exists";
    //         errorMes.current.style.color = "red";
    //         // emailRef.current.focus();
    //       } else {
    //         emailRef.current.style.border = "1px solid black";
    //         passRef.current.style.border = "1px solid red";
    //         errorMes.current.innerHTML = "Password Incorrect";
    //         errorMes.current.style.color = "red";
    //       }
    //     });
    // }
  };

  return (
    <div className="login">
      {/* <div className='items'>
           <div>Finance</div>
           <div>Accounting</div>
           <div>Invoice</div>
       </div> */}
      <div className="login-main">
        '{/* <div className='login-top'> */}
        <img className="img" src={img} alt="" />
        <div className="img2">
          <div  className="menu-container">
            <img src={img1} className="menu_icon" alt="" />

            <div ref={menuRef} className="dropdown-content">
              <a className="hi" href="# ">
                Legacy
              </a>
              <a href="#about">Cubebase</a>
              <a href="#services">Insights</a>
              <a href="#services">Prodigi</a>
            </div>
          </div>
          {/* </div> */}
        </div>
        <div  style={{width:'30%'}} className="login-div ">
          {/* <div className="title">Login </div> */}
            
          <img src={LoginIcon} style={{width:'100%'}} />



          <button onClick={()=>handleSubmit()} class="log">Login</button>
         
        </div>
      </div>
    </div>
  );
}

export default Login;
